import React from 'react';

import { Divider, Grid, Skeleton, SkeletonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { StyledLoadingFieldsetAdvanced } from '../../../../ClassModal/Sections/index.styles';

const CustomSkeleton = (props: SkeletonProps) => <Skeleton {...props} animation="wave"/>;

const StyledLoadingFieldsetAdvanced2 = styled(StyledLoadingFieldsetAdvanced)`
    margin: 0;
    padding: 0.75rem 0;
    border-bottom: none;
    max-width: 600px;
`;

export const ClassDetailLoadingForm = () => (
    <form>
        <Typography variant="h6"><CustomSkeleton width={200}/></Typography>
        <Typography><CustomSkeleton/></Typography>

        <CustomSkeleton width={200} height={60}/>

        <Divider sx={{ my: 2 }}/>

        <Grid container spacing={2}>
            <Grid item>
                <CustomSkeleton width={200} height={60}/>
            </Grid>

            <Grid item>
                <CustomSkeleton width={200} height={60}/>
            </Grid>
        </Grid>

        <CustomSkeleton width={415} height={120}/>
        <CustomSkeleton width={200} height={60}/>

        <Divider sx={{ my: 2 }}/>

        <StyledLoadingFieldsetAdvanced2>
            {[...Array(7).keys()].map((_, index) => <CustomSkeleton sx={{ margin: 0, width: '100%' }} key={index} height={60} />)}
        </StyledLoadingFieldsetAdvanced2>

        <CustomSkeleton width={200} height={60}/>

        <Divider sx={{ my: 2 }}/>

        <CustomSkeleton width={100} height={60}/>
    </form>
);
